module.exports = __webpack_public_path__ + "static/img/new-apple-pay.fe4f01ad.svg";